import BaseSelectionLabel from "./BaseSelectionLabel"
import BaseSelectionPulldown from "./BaseSelectionPulldown";

function BaseSelectionArea({ selectElementData, selectedState, onSelect = f => f }) {
  return (
    <div className="ml-0.5 col-span-2">
      <BaseSelectionLabel name={selectElementData.label} />
      <BaseSelectionPulldown
        selectElementData={selectElementData}
        selectedState={selectedState}
        onSelect={onSelect}
      />
    </div>
  );
}

export default BaseSelectionArea;
